export default "__VITE_ASSET__GDF_$j5oOz7nShNs2BN1nQ__";